export class UniquenessResponse {
  public result = false;
  public duplicationId?: string;
}
